
; (function (win, lib) {
  // eslint-disable-next-line
  var doc = win.document;
  // eslint-disable-next-line
  var docEl = doc.documentElement;
  // eslint-disable-next-line
  var metaEl = doc.querySelector('meta[name="viewport"]');
  // eslint-disable-next-line
  var flexibleEl = doc.querySelector('meta[name="flexible"]');
  // eslint-disable-next-line
  var dpr = 0;
  // eslint-disable-next-line
  var scale = 0;
  // eslint-disable-next-line
  var tid;
  // eslint-disable-next-line
  var flexible = lib.flexible || (lib.flexible = {});

  if (metaEl) {
    console.warn('将根据已有的meta标签来设置缩放比例');
    // eslint-disable-next-line
    var match = metaEl.getAttribute('content').match(/initial\-scale=([\d\.]+)/);
    if (match) {
      scale = parseFloat(match[1]);
      // eslint-disable-next-line
      dpr = parseInt(1 / scale);
    }
  } else if (flexibleEl) {
    // eslint-disable-next-line
    var content = flexibleEl.getAttribute('content');
    if (content) {
      // eslint-disable-next-line
      var initialDpr = content.match(/initial\-dpr=([\d\.]+)/);
      // eslint-disable-next-line
      var maximumDpr = content.match(/maximum\-dpr=([\d\.]+)/);
      if (initialDpr) {
        dpr = parseFloat(initialDpr[1]);
        scale = parseFloat((1 / dpr).toFixed(2));
      }
      if (maximumDpr) {
        dpr = parseFloat(maximumDpr[1]);
        scale = parseFloat((1 / dpr).toFixed(2));
      }
    }
  }

  if (!dpr && !scale) {
    // eslint-disable-next-line
    var isAndroid = win.navigator.appVersion.match(/android/gi);
    // eslint-disable-next-line
    var isIPhone = win.navigator.appVersion.match(/iphone/gi);
    // eslint-disable-next-line
    var devicePixelRatio = win.devicePixelRatio;
    if (isIPhone) {
      // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
      if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
        dpr = 3;
      } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
        dpr = 2;
      } else {
        dpr = 1;
      }
    } else {
      // 其他设备下，仍旧使用1倍的方案
      dpr = 1;
    }
    scale = 1 / dpr;
  }

  docEl.setAttribute('data-dpr', dpr);
  if (!metaEl) {
    metaEl = doc.createElement('meta');
    metaEl.setAttribute('name', 'viewport');
    // eslint-disable-next-line
    metaEl.setAttribute('content', 'initial-scale=' + scale + ', maximum-scale=' + scale + ', minimum-scale=' + scale + ', user-scalable=no');
    if (docEl.firstElementChild) {
      docEl.firstElementChild.appendChild(metaEl);
    } else {
      // eslint-disable-next-line
      var wrap = doc.createElement('div');
      wrap.appendChild(metaEl);
      doc.write(wrap.innerHTML);
    }
  }

  function refreshRem() {
    // eslint-disable-next-line
    var width = docEl.getBoundingClientRect().width;
    if (width / dpr > 540) {
      width = width * dpr;
    }
    // eslint-disable-next-line
    var rem = width / 10;
    // eslint-disable-next-line
    docEl.style.fontSize = rem + 'px';
    // eslint-disable-next-line
    flexible.rem = win.rem = rem;
  }

  // eslint-disable-next-line
  win.addEventListener('resize', function () {
    clearTimeout(tid);
    tid = setTimeout(refreshRem, 300);
  }, false);
  // eslint-disable-next-line
  win.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      clearTimeout(tid);
      tid = setTimeout(refreshRem, 300);
    }
  }, false);

  if (doc.readyState === 'complete') {
    // eslint-disable-next-line
    doc.body.style.fontSize = 12 * dpr + 'px';
  } else {
    // eslint-disable-next-line
    doc.addEventListener('DOMContentLoaded', function (e) {
      // eslint-disable-next-line
      doc.body.style.fontSize = 12 * dpr + 'px';
    }, false);
  }


  refreshRem();

  // eslint-disable-next-line
  flexible.dpr = win.dpr = dpr;
  flexible.refreshRem = refreshRem;
  flexible.rem2px = function (d) {
    // eslint-disable-next-line
    var val = parseFloat(d) * this.rem;
    if (typeof d === 'string' && d.match(/rem$/)) {
      val += 'px';
    }
    return val;
  }
  flexible.px2rem = function (d) {
    // eslint-disable-next-line
    var val = parseFloat(d) / this.rem;
    if (typeof d === 'string' && d.match(/px$/)) {
      val += 'rem';
    }
    return val;
  }
  // eslint-disable-next-line
})(window, window['lib'] || (window['lib'] = {}));
